import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../redux/api';
import { useQuery } from '../../../ReactQuery';
import type { Policy } from '../../../types';

//  Actual function to fetch policies
function fetchPolicies(shouldOmitRules?: boolean) {
  return get<Policy[]>(`/api/policies?omitRules=${shouldOmitRules}`);
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
export const getPoliciesQueryKey = (shouldOmitRules?: boolean): QueryKey => ['policies', { shouldOmitRules }];

/**
 * useTeams is a hook that fetches and returns the teams the
 * current user has access to from /api/teams.
 */
export default function usePolicies(shouldOmitRules: boolean = true, shouldFetch: boolean = true) {
  return useQuery<Policy[]>({
    queryKey: getPoliciesQueryKey(shouldOmitRules),
    queryFn: () => fetchPolicies(shouldOmitRules),
    enabled: shouldFetch,
  });
}
